import { Component, OnInit, OnDestroy, inject} from '@angular/core';
import { LoginComponent } from '../login/login.component';
import { NgIf } from '@angular/common';
import { SessionService } from '../../../../core/services/session.service';



@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
  standalone: true,
  imports: [
    LoginComponent,
    NgIf
  ]
})
export class LoginModalComponent implements OnInit {
  public readonly sessionService = inject(SessionService);


  ngOnInit() {

  }



}
